import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';
import { THEME_PREFERENCE } from '@shared/di/theme-preference.token';
import { DARK_MODE_SELECTOR } from './dark-mode-selector.constants';

@Component({
  selector: 'app-dark-mode-selector',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Tooltip
  ],
  templateUrl: './dark-mode-selector.component.html',
  styleUrl: './dark-mode-selector.component.scss'
})
export class DarkModeSelectorComponent {
  private readonly theme = inject(THEME_PREFERENCE);

  readonly enabled = this.theme.darkMode;

  toggle(): void {
    const element = document.querySelector('html');
    if (element === null) return;
    element.classList.toggle(DARK_MODE_SELECTOR);
    this.theme.setDarkMode(element.classList.contains(DARK_MODE_SELECTOR));
  }
}
